import PropTypes from 'prop-types';
import React from 'react'
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from 'react-modal'
import ReactGA from 'react-ga'

import { shouldBeModal } from "../services/url-analysis";

// Components
import {
    Alerts,
    MetaData,
    RouteCSSTransition,
    Header,
    Footer
} from '~/components'

// Views
import { Community } from '~/views'

// Actions
import { getUserBookmarks } from '~/actions/bookmarks';
import { getUserCamps } from '~/actions/camps';
import { getUserInterests } from '~/actions/interests';
import { getNotifications } from '~/actions/notifications';
import { getInitialSession } from '~/actions/sessions';
import { getUserViewHistory } from '~/actions/viewhistory';


class Wrapper extends React.Component {

    static propTypes = {
        notifications: PropTypes.object.isRequired,
        session: PropTypes.object
    }

    static defaultProps = {
        session: {user: {}}
    }

    wasModal = false;
    isModal = false;
    returnTo = '/discover/';

    getModalStyle = (location) => {
        if (!!/\/workshops/.exec(location.pathname)) return 'workshop-modal';
        if (!!/\/search/.exec(location.pathname)) return 'search-modal';
        if (!!/\/video/.exec(location.pathname)) return 'video-modal';
        return 'content-modal';
    }

    componentWillReceiveProps(nextProps, nextState) {

        var lastProps = this.props,
            changedRoute = nextProps.location.key !== lastProps.location.key,
            rinseChildren = nextProps.location.state && nextProps.location.state.rinseChildren;

        this.wasModal = changedRoute ? shouldBeModal(lastProps.location) : this.wasModal;
        this.isModal = changedRoute ? shouldBeModal(nextProps.location) : this.isModal;
        if (changedRoute && !this.wasModal) this.returnTo = this.isModal ? lastProps.location.pathname : this.returnTo;

        if (changedRoute && this.isModal && !this.wasModal && !rinseChildren) this.previousChildren = this.props.children

        // Make the article pages LOOK like modals
        if (changedRoute && lastProps.location.pathname.startsWith('/articles')) this.wasModal = true
        if (changedRoute && nextProps.location.pathname.startsWith('/articles')) this.isModal = true

    }

    componentDidMount() {
        if( !this.props.session.sessionsAllowed ) return;
        if (!('ID' in this.props.session.user)) this.props.getInitialSession()
        this.props.getNotifications()
        this.props.getUserCamps()
        this.props.getUserInterests()
        this.props.getUserBookmarks()
        this.props.getUserViewHistory()
    }

    componentWillUpdate(nextProps) {
        if ('ID' in this.props.session.user || !('ID' in nextProps.session.user)) return;
        ReactGA.set({userId: nextProps.session.user.ID});
    }

    getClass = () => {
        let slug = this.props.location.pathname.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
        return 'App ' + slug + ('slug' in this.props.match.params && slug.startsWith('articles') ? ' article-page' : '');
    }

    closeModal = (e) => {
        this.props.match.push(this.returnTo)
    }

    render () {

        let {location} = this.props,
            shouldBeAModal = shouldBeModal(location),
            shouldFade = !!location.state && !!location.state.fade,
            modalStyle = this.getModalStyle(location);

        //if(shouldBeAModal) console.log('should be modal')
        //if(this.wasModal) console.log('was modal')
        //if(this.isModal) console.log('is modal')
        //if(!!this.previousChildren) console.log('previousChildren', this.previousChildren)
        //if(shouldBeAModal) console.log('currentChildren', this.props.children)

        return (
            <div className={this.getClass()} key={location.pathname}>

                {/*<MetaData page="init"/>*/}

                <Header notifications={this.props.notifications}
                        session={this.props.session}
                        dispatch={this.props.dispatch}/>

                { this.props.session.sessionsAllowed &&
                    <Alerts />
                }

                <div className="page-content">

                    <RouteCSSTransition
                        component="div"
                        location={location}
                        transitionName={!this.wasModal && !this.isModal && shouldFade ? "window-fade" : "window-snap"}
                        transitionEnterTimeout={300}
                        transitionLeaveTimeout={300}>
                        <div className="page-transition">
                            {shouldBeAModal
                                ? this.isModal && !!this.previousChildren // Now check whether it is a modal and needs an overlay or the content in the background
                                    ? React.cloneElement(this.previousChildren, {
                                        isModalChild: (this.isModal || this.wasModal)
                                    })
                                    : <div className={"OverlayBomaModal modal-fallback " + modalStyle} />
                                : React.cloneElement(this.props.children, {
                                session: this.props.session,
                                isModalChild: (this.isModal || this.wasModal)
                            }) || <Community {...this.props} session={this.props.session}
                                             isModalChild={(this.isModal || this.wasModal)}/>
                            }
                        </div>
                    </RouteCSSTransition>

                    {shouldBeAModal &&
                        <Modal
                            contentLabel="Modal"
                            id="modal-wrapper"
                            isOpen={true}
                            className="BomaModal modal-dialog modal-md"
                            onRequestClose={modalStyle === 'user-modal' ? this.closeModal : () => {
                            }}
                            overlayClassName={"OverlayBomaModal " + modalStyle}>

                            <p className="modal-close">
                                <Link to={this.returnTo}>
                                    <i className="icon-cross" />
                                </Link>
                            </p>

                            {React.cloneElement(this.props.children, {
                                session: this.props.session
                            })}

                        </Modal>
                    }

                </div>

                <Footer session={this.props.session}/>

            </div>
        )
    }

};

const mapStateToProps = state => ({
    session: state.session,
    notifications: state.notifications,
});

const mapDispatchToProps = dispatch => bindActionCreators({ getUserBookmarks, getUserCamps, getUserInterests, getNotifications, getInitialSession, getUserViewHistory }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( withRouter(Wrapper) );



// WEBPACK FOOTER //
// ./src/js/config/wrapper.js